import { useState, useRef, useEffect, Suspense } from 'react';

/**
 * Retrasa el render (y por tanto la descarga del chunk lazy) del contenido
 * hasta que se aproxima al viewport. Reduce el JS inicial y los bytes de red
 * en la carga de la página, mejorando LCP/FCP en móvil.
 */
export default function LazySection({ children, minHeight = 200, rootMargin = '500px' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref} style={{ minHeight: visible ? undefined : minHeight }}>
      {visible && <Suspense fallback={null}>{children}</Suspense>}
    </div>
  );
}